<div
  class="tab-new-providers field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fxLayout="column"
  fusePerfectScrollbar
>
  <div *ngIf="linkProviderForm" class="tab-new-providers__item tab-new-providers__link-provider">
    <p class="tab-new-providers__link-provider_description">
      {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.DESCRIPTION' | translate }}
    </p>

    <div class="tab-new-providers__flex-item tab-new-providers__link-provider__selectors">
      <div class="tab-new-providers__grid tab-new-providers__link-provider__selectors__flex">
        <fc-segment-outlined-select
          [required]="true"
          [label]="'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.SEGMENT' | translate"
          [control]="linkProviderForm.controls.segment"
        ></fc-segment-outlined-select>

        <fc-maintenance-types-outlined-select
          [required]="false"
          [label]="'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.MAINTENANCE_TYPES' | translate"
          [control]="linkProviderForm.controls.maintenanceTypes"
          [findBySegment]="true"
          [segmentId]="linkProviderForm.controls.segment.value && linkProviderForm.controls.segment.value.id"
        ></fc-maintenance-types-outlined-select>
      </div>
      <button
        class="tab-new-providers__link-provider__selectors_button"
        color="primary"
        mat-raised-button
        [disabled]="
          linkProviderForm.invalid ||
          !linkProviderForm.value.maintenanceTypes ||
          !linkProviderForm.value.maintenanceTypes.length
        "
        (click)="linkServiceProvider()"
      >
        {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.CONFIG' | translate }}
      </button>
    </div>

    <ng-container *ngIf="linkProviderForm.hasError('duplicated') && duplicatedServiceProvider">
      <p class="tab-new-providers__link-provider_error-title mt-16">
        {{
          (duplicatedServiceProvider.allMaintenanceTypesAlreadyExists
            ? 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.ERRORS.ALREADY_EXISTS_ALL'
            : 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.ERRORS.ALREADY_EXISTS_TYPES'
          )
            | translate
              : {
                  segmentName: linkProviderForm.value.segment.name
                }
        }}
      </p>
      <ul
        *ngIf="!duplicatedServiceProvider.allMaintenanceTypesAlreadyExists"
        class="tab-new-providers__link-provider__errors"
      >
        <li
          *ngFor="let maintenanceType of duplicatedServiceProvider.maintenanceTypes"
          class="tab-new-providers__link-provider_error-title"
        >
          {{ maintenanceType.name }}
        </li>
      </ul>
    </ng-container>
  </div>

  <div class="tab-new-providers__linked-providers">
    <h2 class="tab-new-providers__linked-providers_title">
      {{
        'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.TITLE'
          | translate: { totalCount: !loadingProviders ? serviceProvidersFormArray.controls.length : '0' }
      }}
    </h2>

    <div
      *ngIf="!serviceProvidersFormArray.controls.length && !loadingProviders"
      class="tab-new-providers__linked-providers__not-found"
    >
      <mat-icon>search_off</mat-icon>
      <p class="tab-new-providers__linked-providers__not-found_title">
        {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.NOT_FOUND' | translate }}
      </p>
    </div>

    <ng-container *ngIf="loadingProviders">
      <div class="tab-new-providers__loading">
        <mat-spinner diameter="64"></mat-spinner>
        <span> {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.LOADING_SERVICE_PROVIDERS' | translate }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="!loadingProviders">
      <div
        *ngFor="let serviceProviderControl of serviceProvidersFormArray.controls; index as index"
        class="tab-new-providers__item tab-new-providers__linked-providers__item"
      >
        <div>
          <h3 class="tab-new-providers__linked-providers__item-title">
            {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.ITEM.SEGMENT' | translate }}
          </h3>
          <p class="tab-new-providers__linked-providers__item-description">
            {{ serviceProviderControl.value.segment.name }}
          </p>
        </div>

        <div>
          <h3 class="tab-new-providers__linked-providers__item-title">
            {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINK_PROVIDERS.MAINTENANCE_TYPES' | translate }}
          </h3>
          <p class="tab-new-providers__linked-providers__item-description">
            <ng-container *ngIf="serviceProviderControl.value.maintenanceTypes.length">
              {{ serviceProviderControl.value.maintenanceTypes | map: mappedMaintenanceTypes }}
            </ng-container>
            <ng-container *ngIf="!serviceProviderControl.value.maintenanceTypes.length">
              {{ 'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.ITEM.ALL' | translate }}
            </ng-container>
          </p>
        </div>

        <div class="tab-new-providers__flex-item tab-new-providers__linked-providers__item__selectors">
          <div class="tab-new-providers__grid">
            <fc-company-outlined-select
              [required]="false"
              [label]="'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.ITEM.COMPANY' | translate"
              [control]="serviceProviderControl.get('company')"
            ></fc-company-outlined-select>

            <fc-deadline-contract-outlined-select
              [required]="false"
              [label]="'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.ITEM.DEADLINE_CONTRACT' | translate"
              [control]="serviceProviderControl.get('deadlineContract')"
            ></fc-deadline-contract-outlined-select>
          </div>

          <button
            class="tab-new-providers__linked-providers__item__selectors-button"
            mat-icon-button
            (click)="deleteServiceProvider(index)"
            [matTooltip]="'LOCATIONS.DIALOG.TABS.TAB_PROVIDERS.LINKED_PROVIDERS.ITEM.DELETE' | translate"
            [matTooltipPosition]="'left'"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
